import {
    matchesRoomCount,
    matchesPropertyType,
    matchesFloor,
    matchesBuildingAge,
    matchesHeating,
    getPropertySize
} from './propertyNormalization';

export function propertyMatchesFilters(property, filters = {}) {
    const {
        searchTerm,
        propertyIdFilter,
        propertyType,
        roomCount,
        minPrice,
        maxPrice,
        minSize,
        maxSize,
        buildingAge,
        floor,
        heating,
        locationFilter
    } = filters;

    if (searchTerm?.trim()) {
        const term = searchTerm.toLowerCase().trim();
        const haystack = [
            property.title,
            property.location,
            property.description,
            property.address
        ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();

        if (!haystack.includes(term)) return false;
    }

    if (propertyIdFilter?.trim()) {
        const idTerm = propertyIdFilter.trim().toLowerCase();
        const matchesId = String(property.propertyId || '').toLowerCase().includes(idTerm)
            || String(property.id || '').toLowerCase() === idTerm;
        if (!matchesId) return false;
    }

    if (!matchesPropertyType(property, propertyType)) return false;
    if (!matchesRoomCount(property.rooms, roomCount)) return false;

    const price = Number(property.price) || 0;
    if (minPrice && !Number.isNaN(Number(minPrice)) && price < parseInt(minPrice, 10)) {
        return false;
    }
    if (maxPrice && !Number.isNaN(Number(maxPrice)) && price > parseInt(maxPrice, 10)) {
        return false;
    }

    const size = getPropertySize(property);
    if (minSize && !Number.isNaN(Number(minSize)) && size < parseInt(minSize, 10)) {
        return false;
    }
    if (maxSize && !Number.isNaN(Number(maxSize)) && size > parseInt(maxSize, 10)) {
        return false;
    }

    if (!matchesBuildingAge(property.buildingAge, buildingAge)) return false;
    if (!matchesFloor(property.floor, floor)) return false;
    if (!matchesHeating(property.heating, heating)) return false;

    if (locationFilter && locationFilter !== 'all') {
        const location = (property.location || '').toLowerCase();
        if (!location.includes(String(locationFilter).toLowerCase())) return false;
    }

    return true;
}

export function sortProperties(properties, sortBy = 'newest') {
    const sorted = [...properties];

    switch (sortBy) {
        case 'price-low':
            sorted.sort((a, b) => (Number(a.price) || 0) - (Number(b.price) || 0));
            break;
        case 'price-high':
            sorted.sort((a, b) => (Number(b.price) || 0) - (Number(a.price) || 0));
            break;
        case 'size-large':
            sorted.sort((a, b) => getPropertySize(b) - getPropertySize(a));
            break;
        case 'size-small':
            sorted.sort((a, b) => getPropertySize(a) - getPropertySize(b));
            break;
        case 'newest':
        default:
            sorted.sort(
                (a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0)
            );
            break;
    }

    return sorted;
}
